import fetch from 'node-fetch';
import { toastr } from 'react-redux-toastr';
import { startTimeValueToHours, endTimeValueToHours } from './surgeTime';

// An empty input must clear the column, so send null instead of '' which GraphQL rejects for Int/Float
const toNumberOrNull = (value) => (value === '' || value === null || value === undefined ? null : Number(value));

const SURGE_FEE_FIELDS = ['bookingFee', 'shopFee', 'driverFee', 'deliveryFee', 'dropFee', 'distanceFee', 'extraDistanceFee', 'weightFee'];

// Empty fee = keep the normal ServiceFee value during the window.
function serializeSurge(surge) {
    if (!surge) return null;
    const row = {
        startTime: startTimeValueToHours(surge.startTime),
        endTime: endTimeValueToHours(surge.endTime),
        isEnable: surge.isEnable !== false && surge.isEnable !== 'false'
    };
    SURGE_FEE_FIELDS.forEach(field => {
        row[field] = toNumberOrNull(surge[field]);
    });
    return JSON.stringify(row);
}

export default async function submit(values, dispatch) {
    const mutation = `
        mutation updateServiceFee(
            $id: Int,
            $feeType: String,
            $bookingFee: Int,
            $shopFee: Int,
            $driverFee: Int,
            $deliveryFee: Float,
            $dropFee: Float,
            $distanceFee: Float,
            $normalDistanceLimitKm: Int,
            $extraDistanceFee: Float,
            $bookingFeeDriverShare: Float,
            $bookingFeeCompanyShare: Float,
            $surge: String
        ) {
            updateServiceFee(
                id: $id,
                feeType: $feeType
                bookingFee: $bookingFee,
                shopFee: $shopFee,
                driverFee: $driverFee,
                deliveryFee: $deliveryFee,
                dropFee: $dropFee,
                distanceFee: $distanceFee,
                normalDistanceLimitKm: $normalDistanceLimitKm,
                extraDistanceFee: $extraDistanceFee,
                bookingFeeDriverShare: $bookingFeeDriverShare,
                bookingFeeCompanyShare: $bookingFeeCompanyShare,
                surge: $surge
            ) {
                status
                errorMessage
            }
        }
    `;

    const response = await fetch('/graphql', {
        method: 'post',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            query: mutation,
            variables: {
                id: values.id,
                feeType: values.feeType,
                bookingFee: values.bookingFee,
                shopFee: values.shopFee,
                driverFee: values.driverFee,
                deliveryFee: values.deliveryFee,
                dropFee: values.dropFee,
                distanceFee: values.distanceFee,
                normalDistanceLimitKm: toNumberOrNull(values.normalDistanceLimitKm),
                extraDistanceFee: toNumberOrNull(values.extraDistanceFee),
                bookingFeeDriverShare: values.bookingFeeDriverShare / 100,
                bookingFeeCompanyShare: values.bookingFeeCompanyShare / 100,
                surge: serializeSurge(values.surge)
            }
        }),
        credentials: 'include'
    });

    const { data } = await response.json();

    if(data && data.updateServiceFee && data.updateServiceFee.status === 200) {
        toastr.success("Success", "Service Fee Updated!")
    } else {
        toastr.error("Failed", (data && data.updateServiceFee && data.updateServiceFee.errorMessage) || "Update Service Fee failed")
    }
}
